import { Button, message, Table } from 'antd'
import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { Outlet } from "react-router-dom";
import Filter from './../../../components/Filter';
import { useSelector } from 'react-redux';
import axios from 'axios';
import ProfilePopup from '../../../components/ProfilePopup';
function Pharmacists() {
  const navigate = useNavigate();
  const API_URL = import.meta.env.VITE_API_URL;
  const [Pharmacists, setPharmacists] = useState([]);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });
  const [loading, setLoading] = useState(false);
  const accessToken = useSelector((state) => state.user.accessToken);
  const [selectedFilters, setSelectedFilters] = useState({ pharmacyId: null, branchId: null, status: null, search: null });
  const [pharmacies, setPharmacies] = useState([]);
  const [branches, setBranches] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);
  const pharmacyDetails = useSelector((state) => state.user.pharmacyDetails);
  const userType = useSelector((state) => state.user?.user?.roleDetails?.id);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const showModal = (data) => {
    setModalData(data);
    setIsModalOpen(true);
  };

  // filter dropdown
  const [filterDropdowns, setFilterDropdowns] = useState([
    {
      title: 'Pharmacy',
      options: []
    },
    {
      title: 'Branch',
      options: []
    },
    {
      title: 'Status',
      options: ["Active", "Inactive"]
    }

  ]);

  const fetchDropdownData = async () => {
    try {
      if (userType === 4) {
        // Fetch branches for a specific pharmacy
        const responseBranches = await axios.get(`${API_URL}pharmacies?id=${pharmacyDetails.id}`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });

        console.log("responseBranches", responseBranches.data.Pharmacy.BranchesDetails);

        // Process the branch list and branch ID
        const branchList = responseBranches.data.Pharmacy.BranchesDetails.map(Branches => Branches.name);
        const branchListID = responseBranches.data.Pharmacy.BranchesDetails.map(Branches => ({
          id: Branches.id,
          name: Branches.name
        }));

        // Set state for branches and dropdown filter options
        setBranches(branchListID);
        setFilterDropdowns([
          {
            title: 'Branch',
            options: branchList,
          },
          {
            title: "Status",
            options: ["Active", "Inactive"],
          }
        ]);
      } else {
        // Fetch all pharmacies and branches
        const pharmacyResponse = await axios.get(`${API_URL}pharmacies/get-pharmacies?limit=1000`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        const branchResponse = await axios.get(`${API_URL}Branches/get-Branches?limit=1000`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });

        // Process the pharmacy list and branch list
        const pharmacyList = pharmacyResponse.data.Pharmacies.map(pharmacy => pharmacy.name);
        const pharmacyListID = pharmacyResponse.data.Pharmacies.map(pharmacy => ({
          id: pharmacy.id,
          name: pharmacy.name
        }));
        const branchList = branchResponse.data.Branches.map(Branches => Branches.name);
        const branchListID = branchResponse.data.Branches.map(Branches => ({
          id: Branches.id,
          name: Branches.name
        }));
        // Set state for pharmacies, branches, and dropdown filter options
        setPharmacies(pharmacyListID);
        setBranches(branchListID);
        setFilterDropdowns([
          {
            title: "Pharmacy",
            options: pharmacyList,
          },
          {
            title: 'Branch',
            options: branchList,
          },
          {
            title: "Status",
            options: ["Active", "Inactive"],
          }
        ]);
      }

    } catch (error) {
      console.error("Error fetching pharmacies:", error);
      message.error("Failed to load Dropdown data.");
    }
  };


  const fetchPharmacists = async (page = 1, pageSize = 10, pharmacyId = null, branchId = null, active = null, search = null) => {
    setLoading(true);
    const queryParams = new URLSearchParams({
      limit: pageSize,
      page: page,
      ...(active !== null && { active }),
      // For userType 4: branchId takes precedence, else use pharmacyDetails.id
      ...(userType === 4 && {
        ...(branchId ? { branchId } : { pharmacyId: pharmacyDetails.id }),
      }),
      // For other userTypes: include pharmacyId/branchId if they exist
      ...(userType !== 4 && {
        ...(pharmacyId && { pharmacyId }),
        ...(branchId && { branchId }),
      }),
      ...(search && { search }),
    }).toString();


    try {
      const response = await axios.get(`${API_URL}users/get-pharmacists?${queryParams}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const { totalCount } = response.data;
      setPharmacists(response.data.Pharmacists);
      setPagination({
        ...pagination,
        current: page,
        pageSize: pageSize,
        total: totalCount,
      });
    } catch (error) {
      console.error("Error fetching patients:", error);
      message.destroy();
      message.error('Failed to fetch patients');
    } finally {
      setLoading(false);
    }
  }
  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(`${API_URL}users/?id=${id}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (response.status === 200) {
        fetchPharmacists()
        message.success("Pharmacists deleted successfully");
        message.destroy();
      }

    } catch (error) {
      console.error("Error deleting Pharmacists:", error);
      message.destroy();
      message.error("Failed to delete Pharmacists");
    }
  };

  useEffect(() => {
    fetchPharmacists(1, pagination.pageSize, selectedFilters.pharmacyId, selectedFilters.branchId, selectedFilters.status, selectedFilters.search);
  }, [pagination.pageSize, selectedFilters]);



  const handleFilterChange = (key, value) => {
    let updatedFilters = { ...selectedFilters };
    let errorMessageShown = false;
    console.log(`value`, value)
    if (key === "Pharmacy") {
      const pharmacyId = value ? pharmacies.find(ph => ph.name === value)?.id : null;
      updatedFilters.pharmacyId = pharmacyId;
      updatedFilters.branchId = null;
      setFilterOptions((prevOptions) => ({
        ...prevOptions,
        Pharmacy: value,
        Branch: "",
      }));
    }

    if (key === "Branch") {
      const branchId = value ? branches.find(bh => bh.name === value)?.id : null;
      updatedFilters.branchId = branchId;
      updatedFilters.pharmacyId = null;
      setFilterOptions((prevOptions) => ({
        ...prevOptions,
        Branch: value,
        Pharmacy: "",
      }));
    }

    if (key === "Status") {
      const status = value === "Active" ? 1 : value === "Inactive" ? 0 : null;
      updatedFilters.status = status;
      setFilterOptions((prevOptions) => ({
        ...prevOptions,
        Status: value,
      }));
    }

    if (key === "search") {
      // let search = value?.trim() || null;
      updatedFilters.search = value;
    }


    if (key === "") {
      fetchPharmacists();
      updatedFilters = {};
      setFilterOptions({});
    }
    console.log(updatedFilters);
    setSelectedFilters(updatedFilters);

    const { pharmacyId, branchId, status, search } = updatedFilters;
    fetchPharmacists(1, pagination.pageSize, pharmacyId || null, branchId || null, status, search);
  };
  // function to change status active or inactive
  const handleStatusChange = async (id, isActive) => {
    const status = isActive ? 1 : 0;
    try {
      const response = await axios.patch(`${API_URL}Users/?id=${id}`, { active: status },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      if (response.status === 200) {
        fetchPharmacists()
      }
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const columns = [
    {
      title: <span>Pharmacist Name</span>,
      dataIndex: ["userDetails", "firstName"],
      key: "pharm_name",
      render: (text, record) => {
        const { firstName, lastName } = record.userDetails || {};
        return `${firstName || ''} ${lastName || ''}`;
      },
    }
    ,
    {
      title: "Contact ",
      dataIndex: "mobileNumber",
      key: "Contact",
    },
    // {
    //   title: "Patient List",
    //   dataIndex: "Patient_List",
    //   render: (text, row) => (
    //     <div className="row-actions">
    //       <Button
    //         style={{ marginRight: 16, borderRadius: 0, borderColor: "#C0D3F9" }}
    //         onClick={() => handleViewClick()}
    //       >
    //         View
    //       </Button>
    //     </div>
    //   ),
    // },
    {
      title: "Profile",
      dataIndex: "Profile",
      render: (text, row) => (
        <div className="row-actions">
          <Link to="">
            <Button
              style={{ marginRight: 16, borderRadius: 0, borderColor: "#C0D3F9" }}
              onClick={() => showModal(row)}
            >
              View
            </Button>
          </Link>
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "active",
      render: (text, row) => (
        <div className="flex">

          <Button
            disabled={row.active}
            style={{
              borderRadius: 0,
              border: 0,
              margin: 0,
              backgroundColor: row.active ? "#3371EB" : "#F7F8FF",
              color: row.active ? "#FFFFFF" : "#123288",
              cursor: row.active ? "not-allowed" : "pointer",
            }}
            onClick={() => handleStatusChange(row.id, true)}
          >
            Active
          </Button>
          <Button
            disabled={!row.active}
            style={{
              borderRadius: 0,
              margin: 0,
              border: 0,
              backgroundColor: row.active ? "#F7F8FF" : "#3371EB",
              color: row.active ? "#123288" : "#FFFFFF",
              cursor: !row.active ? "not-allowed" : "pointer",
            }}
            onClick={() => handleStatusChange(row.id, false)}
          >
            Inactive
          </Button>
        </div>
      ),
    },

  ]

  if (userType === 1) {
    columns.push({
      title: "Delete",
      key: "delete",
      render: (text, row) => (
        <Button
          danger
          style={{ borderRadius: 0, borderColor: "#FF4D4F", backgroundColor: "#FF4D4F", color: "#FFFFFF" }}
          onClick={() => handleDelete(row.id)}
        >
          Delete
        </Button>
      ),
    });
  }
  const [filterOptions, setFilterOptions] = useState({})
  useEffect(() => {
    fetchDropdownData()
  }, [])
  const handleTableChange = (newPagination) => {
    fetchPharmacists(newPagination.current, newPagination.pageSize, selectedFilters.pharmacyId, selectedFilters.branchId, selectedFilters.status, selectedFilters.search);
  };
  return (
    <>
      {isModalOpen && (
        <ProfilePopup
          isOpen={isModalOpen}
          closeModal={closeModal}
          data={modalData}
        />
      )}
      <div className=' space-y-5 '>
        <Filter
          filterOptions={filterOptions}
          setFilterOptions={setFilterOptions}
          dropdowns={filterDropdowns}
          addItemName='Add Pharmacist'
          addItemUrl='AddPharmacists'
          searchBarPlaceholder='Search Pharmacist'
          onFilterChange={handleFilterChange}

        />
        <Table
          className="customTable"
          style={{ backgroundColor: '#FFFFFF', padding: "10px" }}
          columns={columns}
          dataSource={Pharmacists}
          rowKey="id"
          loading={loading}
          pagination={pagination}
          onChange={handleTableChange}

        />
      </div >
      <Outlet />
    </>
  )
}

export default Pharmacists
